<button #button class="mdc-button" [disabled]="disabled" (blur)="onBlur($event)" (click)="click()">
  <span class="mdc-button__label">
    <ng-content></ng-content>
  </span>
</button>